import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'picking.hideViewButton'.
 *
 * Styrer om «Vis»-knappen (forhåndsvisning av plukklisteinnhold) skal skjules i
 * operatørens plukkmodul — anti-cherry-picking: operatøren skal ikke kunne inspisere
 * innholdet i tilgjengelige plukklister før hen tar en (Haucon, Teamwork 36333977).
 *
 * Oppløsning følger hierarkiet Profile -> System -> Default via getEffectiveSetting
 * (SettingDefinition tillater både System- og Profile-nivå, migrasjon 079).
 *
 * Default: false (knappen vises — dagens oppførsel for alle tenanter).
 * Ved feil i oppslaget faller vi tilbake til å VISE knappen; funksjonen er en
 * innstramming og skal aldri kunne blokkere normal drift.
 */
export function usePickingHideViewButton(): { hideViewButton: boolean; loaded: boolean } {
  const [hideViewButton, setHideViewButton] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('picking.hideViewButton');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setHideViewButton(val === 'true' || val === '1' || val === 'ja');
          } else {
            setHideViewButton(false);
          }
        }
      } catch (err) {
        console.warn('Could not load picking.hideViewButton setting, defaulting to false:', err);
        if (!cancelled) {
          setHideViewButton(false);
        }
      } finally {
        if (!cancelled) {
          setLoaded(true);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return { hideViewButton, loaded };
}
